"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityStatus = void 0;
var EligibilityStatus;
(function (EligibilityStatus) {
    EligibilityStatus["ELIGIBILITY_PENDING"] = "Decision Pending";
    EligibilityStatus["ELIGIBLE"] = "Qualified";
    EligibilityStatus["PROBABLY_ELIGIBLE"] = "Probably Qualified";
    EligibilityStatus["NOT_ELIGIBLE"] = "Not Qualified";
})(EligibilityStatus || (exports.EligibilityStatus = EligibilityStatus = {}));
